// src/components/Layout.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SocialSidebar from "./SocialSidebar";

export default function Layout({ children }) {
  return (
    <div className="app-layout">
      <Header />
      <SocialSidebar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
